module.exports = __webpack_public_path__ + "img/tw.3c944f89.svg";